import HttpHelpers from '../helpers';

const PayoutsApiEndpoints = {
  getPayoutMethods: (params) => {
    return HttpHelpers.authenticatedAxios
      .get('host/bank-detail', { params })
      .then((response) => response.data);
  },
  createPayoutMethod: (data) => {
    return HttpHelpers.authenticatedAxios
      .post('host/bank-detail', data)
      .then((response) => response.data);
  },
  getPayoutMethod: (id) => {
    return HttpHelpers.authenticatedAxios
      .get(`host/bank-detail/${id}`)
      .then((response) => response.data);
  },
  updatePayoutMethod: (id, data) => {
    return HttpHelpers.authenticatedAxios
      .patch(`host/bank-detail/${id}`, data)
      .then((response) => response.data);
  },
  deletePayoutMethod: (id) => {
    return HttpHelpers.authenticatedAxios
      .delete(`host/bank-detail/${id}`)
      .then((response) => response.data);
  },
};

export default PayoutsApiEndpoints;
